import React from "react";
import "../styles/FeatureSection.css";

const FeatureSection = () => {
    return (
        <section id="features" className="feature-section">
            <h2>Kenapa Memilih Kami?</h2>
            <div className="feature-grid">
                <div className="feature-card">
                    <h3>Monitoring IoT</h3>
                    <p>Sensor otomatis memantau kualitas air dan stok galon secara real-time.</p>
                </div>
                <div className="feature-card">
                    <h3>Keamanan Data</h3>
                    <p>Autentikasi JWT untuk login aman dan terenkripsi, memastikan perlindungan data.</p>
                </div>
                <div className="feature-card">
                    <h3>Analitik Bisnis</h3>
                    <p>Data real-time membantu pengambilan keputusan bisnis yang lebih cerdas.</p>
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
